export default __webpack_public_path__ + "static/media/text-messages.603eb76f.svg";